module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingroom"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/waomeeting-01-4.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/recording_podcast.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Meeting room 🤝")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("🧠 Perfect for brainstorming and meeting clients")]), _vm._v(" "), _c('p', [_vm._v("📍 Downtown location")]), _vm._v(" "), _c('p', [_vm._v("💺 Capacity 10 seats ")]), _vm._v(" "), _c('p', [_vm._v("📽 Projector with Chromecast")]), _vm._v(" "), _c('p', [_vm._v("🎨 Whiteboard")]), _vm._v(" "), _c('p', [_vm._v("🎧 Acoustically insulated ")]), _vm._v(" "), _c('p', [_vm._v("🎧 Great for Podcasts")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our meeting room you are supporting community space")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Meeting Room!"
    }
  }, [_vm._v("\n            Book meeting room")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/spoznajkandidata.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/meeting_room_february_2020.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/pb-02.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58268576","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeetingRoom.vue
// module id = 248
// module chunks = 18